import { Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../../../../../components/checkbox/Checkbox";
import CustomInput from "../../../../../../../components/customInput/CustomInput";
import CustomTextarea from "../../../../../../../components/CustomTextarea/CustomTextarea";
import RadioChoices from "../../../../../../../components/radioChoices/RadioChoices";
import CoursePick from "../../../../OdobrenjeAplikacija/PostKomentar/CoursePick";
import SelectDropdown from "../../selectDropdown/SelectDropdown";
import ColorCodedInput from "../ColorCodedInput";
import styles from "../EnrollmentForm.module.css";
import UserInfo from "../UserInfo";
import { attendanceMappingTP1 } from "../utils";

function TP1Form({
  userId,
  formMethodsThree,
  handleResetForm,
  programApplicationId,
  applicationsCreated,
  evidentionUserID,
  isAccepted,
  errorFields,
  application,
  commentModal,
  fetchApplicationCallback,
}) {
  const { watch, control } = formMethodsThree;
  const navigate = useNavigate();
  const getCourseContext = (course) => {
    return {
      userId,
      application,
      commentModal,
      course,
      evidentionUserID,
      fetchApplicationCallback,
    };
  };
  const getBackgroundColor = (fieldName, value) => {
    return attendanceMappingTP1[fieldName] >= Number(value)
      ? "#FEE8E8"
      : "#E8FEE8";
  };
  const choiceFourTP1 = watch("choiceFourTP1");
  const questionSixTP1 = watch("questionSixTP1");
  const questionSevenTP1 = watch("questionSevenTP1");
  return (
    <div>
      <div className={styles.formInputsContainer}>
        {userId !== "Polaznik" && (
          <UserInfo
            evidentionUserID={
              evidentionUserID ? evidentionUserID : application?.userId
            }
            course={"TP1"}
          />
        )}
        <p className={styles.formSectionText}>
          Pozdrav,u svrhu prijave za upis u Terapeutski praktikum 1
          &#40;TP1&#41; molimo te da popuniš obrazac u nastavku.
          <br />
          <br />U slučaju većeg broja prijavljenih nego što možemo primiti
          prednost će imati oni koji zadovoljavaju veći broj propisanih uvjeta.
          <br />
          Za upis TP1 je preduvjet sudjelovanje na svim predavanjima programa
          Osobni razvoj kao i na minimalno 17 radionica po godini, a za eOR je
          obavezno sudjelovanje na minimalno 14 radionica po godini i svim
          Modulima uživo minimalno 5 radionica po modulu.
          <br />
        </p>
        <div className={styles.displayColumn}>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="evidentionOR1Lessons"
              labelText="1. godina OR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
            <ColorCodedInput
              name="evidentionOR1Workshops"
              labelText="1. godina OR - broj radionica (min 17)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
          </div>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="evidentionOR2Lessons"
              labelText="2. godina OR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
            <ColorCodedInput
              name="evidentionOR2Workshops"
              labelText="2. godina OR - broj radionica (min 17)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
          </div>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="evidentionEOR1Lessons"
              labelText="1. godina eOR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
            <ColorCodedInput
              name="evidentionEOR1Workshops"
              labelText="1. godina eOR - broj radionica (min 14)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
            <ColorCodedInput
              name="evidentionEOR1LiveModule"
              labelText="1. godina eOR - broj Modula uživo (min 5)"
              width="29%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
          </div>
          <div className={styles.displayRow}>
            <ColorCodedInput
              name="evidentionEOR2Lessons"
              labelText="2. godina eOR - broj predavanja (6)"
              width="25%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
            <ColorCodedInput
              name="evidentionEOR2Workshops"
              labelText="2. godina eOR - broj radionica (min 14)"
              width="27%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
            <ColorCodedInput
              name="evidentionEOR2LiveModule"
              labelText="2. godina eOR - broj Modula uživo (min 5)"
              width="29%"
              control={control}
              attendanceMapping={attendanceMappingTP1}
            />
          </div>
        </div>
        <br />
        <Controller
          control={formMethodsThree.control}
          name="checkOneTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <Checkbox
              onBlur={onBlur}
              error={errorFields.find((field) => field === "checkOneTP1")}
              onChange={
                userId !== "Referada" && !programApplicationId && onChange
              }
              value={value}
              disabled={applicationsCreated["TP1"] || evidentionUserID}
              label="Potvrđujem da sam u Moj profil pohranio skeniranu potvrdu o nekažnjavanju u kojoj je vidljivo da nisam pravomoćno osuđen/a za neko od kaznenih djela navedenih u Zakonu o djelatnosti psihoterapije."
            />
          )}
        />
        <Controller
          control={formMethodsThree.control}
          name="questionOneTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              error={errorFields.find((field) => field === "questionOneTP1")}
              value={value}
              name="questionOneTP1"
              labelText="Navedi ako imaš dodatne edukacije iz područja psihoterapije ili nekog sličnog rada na sebi."
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["TP1"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsThree.control}
          name="choiceOneTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <RadioChoices
              name="choiceOneTP1"
              onBlur={onBlur}
              error={errorFields.find((field) => field === "choiceOneTP1")}
              onChange={
                userId !== "Referada" &&
                !programApplicationId &&
                !evidentionUserID &&
                !applicationsCreated["TP1"]
                  ? onChange
                  : undefined
              }
              value={value}
              disabled={applicationsCreated["TP1"] || evidentionUserID}
              title="Imaš li riješene sve financijske obaveze prema školi od prethodnih godina što je preduvjet za upis TP1?"
              choices={[
                "Da",
                "Ne još, javit ću se računovodstvu (racunovodstvo@ipd-center.eu)",
              ]}
            />
          )}
        />
        <Controller
          control={formMethodsThree.control}
          name="choiceTwoTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <RadioChoices
              name="choiceTwoTP1"
              error={errorFields.find((field) => field === "choiceTwoTP1")}
              onBlur={onBlur}
              onChange={
                userId !== "Referada" &&
                !programApplicationId &&
                !evidentionUserID &&
                !applicationsCreated["TP1"]
                  ? onChange
                  : undefined
              }
              value={value}
              disabled={applicationsCreated["TP1"] || evidentionUserID}
              title="Uvjet za upis TP1 su ispunjene sve introspekcije do zadnjeg predavanja OR-a koje si imao/la. Imaš li ispunjene sve introspekcije do sada?"
              choices={["Da", "Ne"]}
            />
          )}
        />
        <CustomInput
          value={formMethodsThree.watch("questionTwoTP1")}
          name="questionTwoTP1"
          labelText="Uvjet za upis u TP1 je min 24 sata programskih terapija (IPR-a). Broj tvojih programskih terapija do današnjeg datuma unesenih u školski sustav:"
          placeholder="Upiši"
          disabled={true}
          backgroundColor={getBackgroundColor(
            "questionTwoTP1",
            formMethodsThree.watch("questionTwoTP1")
          )}
        />
        <Controller
          control={formMethodsThree.control}
          name="questionThreeTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              error={errorFields.find((field) => field === "questionThreeTP1")}
              value={value}
              name="questionThreeTP1"
              labelText="Ako si dobio/la uvjetan upis u TP1 (naknadno ispunjavanje uvjeta za terapije koje ti nedostaju) napiši broj terapija koje ti nedostaju i do kojeg datuma ti je mentor dao da ispuniš uvjete."
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["TP1"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsThree.control}
          name="questionFourTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomTextarea
              onBlur={onBlur}
              onChange={onChange}
              error={errorFields.find((field) => field === "questionFourTP1")}
              value={value}
              name="questionFourTP1"
              labelText="Opiši: kako sada vidiš svoje trenutne kapacitete da budeš na TP-u, što misliš sada na čemu trebaš raditi kod sebe kako bi na TP2 mogao/la početi raditi s ljudima:"
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["TP1"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsThree.control}
          name="questionFiveTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomTextarea
              onBlur={onBlur}
              onChange={onChange}
              error={errorFields.find((field) => field === "questionFiveTP1")}
              value={value}
              name="questionFiveTP1"
              labelText="Opiši zašto želiš upisati TP, što je tvoja motivacija da budeš terapeut:"
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["TP1"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsThree.control}
          name="choiceThreeTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <RadioChoices
              name="choiceThreeTP1"
              error={errorFields.find((field) => field === "choiceThreeTP1")}
              onBlur={onBlur}
              onChange={
                userId !== "Referada" &&
                !programApplicationId &&
                !evidentionUserID &&
                !applicationsCreated["TP1"]
                  ? onChange
                  : undefined
              }
              value={value}
              disabled={applicationsCreated["TP1"] || evidentionUserID}
              title="Označi u kojoj grupi bi želio/željela pohađati radionice TP1 (napomena: Termini grupa (radionica TP1) za koje se trebaš odlučiti su ti dostavljeni u e-mailu. Škola ne garantira da ćeš u željenom terminu pohađati TP1 pa je važno da odabereš i alternativni termin/grupu. Nakon što završe prijave i oforme se grupe, potvrdit ćemo ti s kojom grupom ćeš pohađati TP shodno mogućnostima i broju prijava)"
              choices={[
                "1.	GRUPA: uživo u ZG unutar tri vikenda - prednost imaju polaznici iz Ljubljane, Splita, Zagreba",
                "2.	GRUPA: uživo u ZG unutar dva vikenda - prednost imaju polaznici eOR-a",
                "3.	GRUPA: radnim danom od 18h-21:15h (Zagreb uživo + Beograd istovremeno preko ZOOM-a u BG prostoru)",
              ]}
            />
          )}
        />
        <Controller
          control={formMethodsThree.control}
          name="selectOneTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <SelectDropdown
              name="selectOneTP1"
              error={errorFields.find((field) => field === "selectOneTP1")}
              title="U slučaju da će neke grupe biti popunjene i neki će morati prijeći u druge grupe navedi koja bi ti alternativna grupa odgovarala:"
              onChange={
                userId !== "Referada" && !programApplicationId && onChange
              }
              onBlur={onBlur}
              value={value}
              initialOption={!programApplicationId ? "Odaberi" : value}
              options={[
                "1.	GRUPA: uživo u ZG unutar tri vikenda - prednost imaju polaznici iz Ljubljane, Splita, Zagreba",
                "2.	GRUPA: uživo u ZG unutar dva vikenda - prednost imaju polaznici eOR-a",
                "3.	GRUPA: radnim danom od 18h-21:15h (Zagreb uživo + Beograd istovremeno preko ZOOM-a u BG prostoru)",
              ]}
              disabled={
                programApplicationId ||
                applicationsCreated["TP1"] ||
                evidentionUserID
              }
            />
          )}
        />
        <p className={styles.opisP}>
          Predavanja za sve grupe TP1 su od 18h-21:15h <br /> Zagreb - obavezan
          dolazak uživo, ostali gradovi – ZOOM
        </p>
        <Controller
          control={formMethodsThree.control}
          name="choiceFourTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <RadioChoices
              name="choiceFourTP1"
              error={errorFields.find((field) => field === "choiceFourTP1")}
              onBlur={onBlur}
              onChange={
                userId !== "Referada" &&
                !programApplicationId &&
                !evidentionUserID &&
                !applicationsCreated["TP1"]
                  ? onChange
                  : undefined
              }
              value={value}
              disabled={applicationsCreated["TP1"] || evidentionUserID}
              title="Upisani TP1 program plaćam kao:"
              choices={["Privatna osoba", "Firma"]}
            />
          )}
        />
        {choiceFourTP1 === "Firma" &&
          (!questionSevenTP1 || questionSevenTP1.trim() === "") && (
            <Controller
              control={formMethodsThree.control}
              name="questionSixTP1"
              render={({ field: { onChange, onBlur, value } }) => (
                <CustomInput
                  onBlur={onBlur}
                  onChange={onChange}
                  error={errorFields.includes("questionSixTP1")}
                  value={value}
                  name="questionSixTP1"
                  labelText="Kao firma iz Hrvatske navodim adresu, grad i državu sjedišta firme i oib firme:"
                  placeholder="Upiši"
                  disabled={
                    userId === "Referada" ||
                    programApplicationId ||
                    applicationsCreated["TP1"] ||
                    evidentionUserID
                  }
                />
              )}
            />
          )}

        {choiceFourTP1 === "Firma" &&
          (!questionSixTP1 || questionSixTP1.trim() === "") && (
            <Controller
              control={formMethodsThree.control}
              name="questionSevenTP1"
              render={({ field: { onChange, onBlur, value } }) => (
                <CustomInput
                  onBlur={onBlur}
                  onChange={onChange}
                  error={errorFields.includes("questionSevenTP1")}
                  value={value}
                  name="questionSevenTP1"
                  labelText="Kao firma iz drugih država (osim Hrvatske)..."
                  placeholder="Upiši"
                  disabled={
                    userId === "Referada" ||
                    programApplicationId ||
                    applicationsCreated["TP1"] ||
                    evidentionUserID
                  }
                />
              )}
            />
          )}

        <Controller
          control={formMethodsThree.control}
          name="questionEightTP1"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              name="questionEightTP1"
              labelText="Ovdje možeš upisati svoju napomenu ili eventualno dodatno pitanje:"
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["TP1"] ||
                evidentionUserID
              }
            />
          )}
        />
      </div>
      {userId === "Polaznik" && (
        <p
          className={styles.opisP}
          style={{
            marginLeft: 80,
            marginRight: 80,
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          Više o tome što se očekuje od polaznika kao osobni preduvjeti za upis
          u TP možeš pročitati u rubrici Dokumenti - KRITERIJI KOD EVALUACIJE
          POLAZNIKA ZA UPIS U 3. STUPANJ EDUKACIJE: TERAPEUTSKI PRAKTIKUM (TP)
        </p>
      )}
      {userId !== "Referada" && !programApplicationId && !evidentionUserID && (
        <div className={styles.formButtonsContainer}>
          {!applicationsCreated["TP1"] && (
            <div
              className={
                userId === "Referada"
                  ? `${styles.disabled} ${styles.cancelButton}`
                  : styles.cancelButton
              }
              onClick={() => {
                if (userId !== "Referada" && !programApplicationId) {
                  formMethodsThree.reset();
                  navigate(-1);
                }
              }}
              disabled={true}
            >
              odustani
            </div>
          )}
          <div
            className={
              userId === "Referada" || applicationsCreated["TP1"]
                ? `${styles.disabled} ${styles.sendButton}`
                : styles.sendButton
            }
            onClick={() => {
              if (userId !== "Referada") handleResetForm(formMethodsThree);
            }}
            disabled={applicationsCreated["TP1"]}
          >
            {applicationsCreated["TP1"] ? "Poslano" : "Pošalji prijavu"}
          </div>
        </div>
      )}
      <CoursePick context={getCourseContext("TP1")} />
      {userId === "Polaznik" &&
        !evidentionUserID &&
        !programApplicationId &&
        applicationsCreated["TP1"] && (
          <>
            {isAccepted["TP1"] !== false && (
              <div
                className={styles.acceptanceContainer}
                style={{
                  backgroundColor:
                    isAccepted["TP1"] === true &&
                    commentModal["TP1"]?.isReferadaAccepted === true
                      ? "#e8fee8"
                      : "#F8F9FB",
                }}
              >
                {isAccepted["TP1"] === true &&
                commentModal["TP1"]?.isReferadaAccepted === true
                  ? "Primljeni ste"
                  : "Vaša aplikacija je zaprimljena"}
              </div>
            )}
          </>
        )}
    </div>
  );
}

export default TP1Form;
